import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CompactIconButton = styled(IconButton)(({ theme }) => ({
  '&&': { padding: theme.spacing(0.25), fontSize: 16 },
}));
